import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const LoginPage: React.FC = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!login || !password) {
      toast.error('أدخل البريد/الجوال وكلمة المرور');
      return;
    }

    try {
      setLoading(true);
      const res = await api.post('/auth/login', {
        login,
        password,
      });
      const { token, user } = res.data.data;
      authLogin(token, user);
      toast.success(`أهلاً ${user.name}`);
      navigate('/');
    } catch (err: any) {
      toast.error(err.response?.data?.message || 'بيانات الدخول غير صحيحة');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-sm p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-primary-500 mb-2">الجلب</h1>
          <p className="text-gray-500 text-sm">سوق الحلال</p>
        </div>

        <form onSubmit={handleSubmit}>
          <h2 className="text-lg font-bold text-gray-800 mb-6 text-center">تسجيل الدخول</h2>

          <div className="mb-4">
            <label className="block text-sm text-gray-600 mb-2">البريد الإلكتروني أو رقم الجوال</label>
            <input
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              placeholder="example@email.com أو 05XXXXXXXX"
              className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              dir="ltr"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm text-gray-600 mb-2">كلمة المرور</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="كلمة المرور"
              className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary-500 text-white py-3 rounded-lg font-semibold hover:bg-primary-600 transition disabled:opacity-50"
          >
            {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
          </button>

          <p className="text-center text-sm text-gray-400 mt-6">
            ليس لديك حساب؟{' '}
            <Link to="/register" className="text-primary-500 font-semibold">إنشاء حساب</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
